module.exports = __webpack_public_path__ + "static/media/icon.d2a59b9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/icon/icon.svg
// module id = ./src/components/ui/icon/icon.svg
// module chunks = 0